import { useAiChat as e } from "./useAiChat.mjs";
import { adminAiApi as t, aiApi as n } from "@maat/api-ai";
import { useMutation as r } from "@maat/store-hooks";
//#region src/hooks/useRateAiMessageMutation.ts
var i = () => {
	let { surface: i } = e(), a = i === "admin" ? t.rateMessage : n.rateMessage;
	return r({ mutationFn: (e) => a(e.messageId, {
		rating: e.rating,
		comment: e.comment
	}) });
};
//#endregion
export { i as useRateAiMessageMutation };
